import Cookies from 'js-cookie';
import { UD_COOKIES } from './constants';

/**
 * Returns given cookie's value either raw (as string) or actual (object, string, boolean etc.). In default, it returns
 * parsed value of the cookie means actual value.
 *
 * @param cookie name of the cookie as string
 * @param raw a boolean indicated whether function should return raw value of the cookie, if it does exist, or not
 */
export const getCookie = function (cookie) {
  let raw = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (raw) {
    var _Cookies$get;
    return (_Cookies$get = Cookies.get(cookie)) !== null && _Cookies$get !== void 0 ? _Cookies$get : undefined;
  }
  try {
    var _Cookies$getJSON;
    // Try to parse it if it's possible
    return (_Cookies$getJSON = Cookies.getJSON(cookie)) !== null && _Cookies$getJSON !== void 0 ? _Cookies$getJSON : undefined;
  } catch (e) {
    var _Cookies$get2;
    // If it's not parsable, return the value directly
    return (_Cookies$get2 = Cookies.get(cookie)) !== null && _Cookies$get2 !== void 0 ? _Cookies$get2 : undefined;
  }
};
export const isFirstTimeVisitor = () => !Boolean(getCookie(UD_COOKIES.FIRST_VISIT_COOKIE_KEY));
//# sourceMappingURL=get-cookie.js.map